import { BOOKING_APPLICATION_QUESTION_OPTION_MODEL } from "@/models/booking-application-question-option-model";
import pluralize from "pluralize";
import { BOOKING_MODEL } from "@/models/booking-model";

export const BOOKING_APPLICATION_QUESTION_MODEL =
  "booking-application-question";

const bookingApplicationQuestionModel = {
  question: "",
  inputType: "",
  explanation: "",
  characterLimit: null,
  required: false,
  optionsTemplate: [],
  options: {
    type: pluralize(BOOKING_APPLICATION_QUESTION_OPTION_MODEL),
    jsonApi: "hasMany"
  },
  booking: {
    jsonApi: "hasOne",
    type: pluralize(BOOKING_MODEL)
  }
};

export default bookingApplicationQuestionModel;
